export default {
    navigation: 50,
    header: 50,
    headerFilter: 40,
};
